const countryPrefixList = [
  {
      "name": "Afghanistan",
      "dial_code": "+93",
      "code": "AF",
      "flag_url": "af.png"
  }, {
      "name": "Aland Islands",
      "dial_code": "+358",
      "code": "AX",
      "flag_url": "ax.png"
  }, {
      "name": "Albania",
      "dial_code": "+355",
      "code": "AL",
      "flag_url": "al.png"
  }, {
      "name": "Algeria",
      "dial_code": "+213",
      "code": "DZ",
      "flag_url": "dz.png"
  }, {
      "name": "AmericanSamoa",
      "dial_code": "+1684",
      "code": "AS",
      "flag_url": "as.png"
  }, {
      "name": "Andorra",
      "dial_code": "+376",
      "code": "AD",
      "flag_url": "ad.png"
  }, {
      "name": "Angola",
      "dial_code": "+244",
      "code": "AO",
      "flag_url": "ao.png"
  }, {
      "name": "Anguilla",
      "dial_code": "+1264",
      "code": "AI",
      "flag_url": "ai.png"
  }, {
      "name": "Antarctica",
      "dial_code": "+672",
      "code": "AQ",
      "flag_url": "aq.png"
  }, {
      "name": "Antigua and Barbuda",
      "dial_code": "+1268",
      "code": "AG",
      "flag_url": "ag.png"
  }, {
      "name": "Argentina",
      "dial_code": "+54",
      "code": "AR",
      "flag_url": "ar.png"
  }, {
      "name": "Armenia",
      "dial_code": "+374",
      "code": "AM",
      "flag_url": "am.png"
  }, {
      "name": "Aruba",
      "dial_code": "+297",
      "code": "AW",
      "flag_url": "aw.png"
  }, {
      "name": "Australia",
      "dial_code": "+61",
      "code": "AU",
      "flag_url": "au.png"
  }, {
      "name": "Austria",
      "dial_code": "+43",
      "code": "AT",
      "flag_url": "at.png"
  }, {
      "name": "Azerbaijan",
      "dial_code": "+994",
      "code": "AZ",
      "flag_url": "az.png"
  }, {
      "name": "Bahamas",
      "dial_code": "+1242",
      "code": "BS",
      "flag_url": "bs.png"
  }, {
      "name": "Bahrain",
      "dial_code": "+973",
      "code": "BH",
      "flag_url": "bh.png"
  }, {
      "name": "Bangladesh",
      "dial_code": "+880",
      "code": "BD",
      "flag_url": "bd.png"
  }, {
      "name": "Barbados",
      "dial_code": "+1246",
      "code": "BB",
      "flag_url": "bb.png"
  }, {
      "name": "Belarus",
      "dial_code": "+375",
      "code": "BY",
      "flag_url": "by.png"
  }, {
      "name": "Belgium",
      "dial_code": "+32",
      "code": "BE",
      "flag_url": "be.png"
  }, {
      "name": "Belize",
      "dial_code": "+501",
      "code": "BZ",
      "flag_url": "bz.png"
  }, {
      "name": "Benin",
      "dial_code": "+229",
      "code": "BJ",
      "flag_url": "bj.png"
  }, {
      "name": "Bermuda",
      "dial_code": "+1441",
      "code": "BM",
      "flag_url": "bm.png"
  }, {
      "name": "Bhutan",
      "dial_code": "+975",
      "code": "BT",
      "flag_url": "bt.png"
  }, {
      "name": "Bolivia, Plurinational State of",
      "dial_code": "+591",
      "code": "BO",
      "flag_url": "bo.png"
  }, {
      "name": "Bosnia and Herzegovina",
      "dial_code": "+387",
      "code": "BA",
      "flag_url": "ba.png"
  }, {
      "name": "Botswana",
      "dial_code": "+267",
      "code": "BW",
      "flag_url": "bw.png"
  }, {
      "name": "Brazil",
      "dial_code": "+55",
      "code": "BR",
      "flag_url": "br.png"
  }, {
      "name": "British Indian Ocean Territory",
      "dial_code": "+246",
      "code": "IO",
      "flag_url": "io.png"
  }, {
      "name": "Brunei Darussalam",
      "dial_code": "+673",
      "code": "BN",
      "flag_url": "bn.png"
  }, {
      "name": "Bulgaria",
      "dial_code": "+359",
      "code": "BG",
      "flag_url": "bg.png"
  }, {
      "name": "Burkina Faso",
      "dial_code": "+226",
      "code": "BF",
      "flag_url": "bf.png"
  }, {
      "name": "Burundi",
      "dial_code": "+257",
      "code": "BI",
      "flag_url": "bi.png"
  }, {
      "name": "Cambodia",
      "dial_code": "+855",
      "code": "KH",
      "flag_url": "kh.png"
  }, {
      "name": "Cameroon",
      "dial_code": "+237",
      "code": "CM",
      "flag_url": "cm.png"
  }, {
      "name": "Canada",
      "dial_code": "+1",
      "code": "CA",
      "flag_url": "ca.png"
  }, {
      "name": "Cape Verde",
      "dial_code": "+238",
      "code": "CV",
      "flag_url": "cv.png"
  }, {
      "name": "Cayman Islands",
      "dial_code": "+345",
      "code": "KY",
      "flag_url": "ky.png"
  }, {
      "name": "Central African Republic",
      "dial_code": "+236",
      "code": "CF",
      "flag_url": "cf.png"
  }, {
      "name": "Chad",
      "dial_code": "+235",
      "code": "TD",
      "flag_url": "td.png"
  }, {
      "name": "Chile",
      "dial_code": "+56",
      "code": "CL",
      "flag_url": "cl.png"
  }, {
      "name": "China",
      "dial_code": "+86",
      "code": "CN",
      "flag_url": "cn.png"
  }, {
      "name": "Christmas Island",
      "dial_code": "+61",
      "code": "CX",
      "flag_url": "cx.png"
  }, {
      "name": "Cocos (Keeling) Islands",
      "dial_code": "+61",
      "code": "CC",
      "flag_url": "cc.png"
  }, {
      "name": "Colombia",
      "dial_code": "+57",
      "code": "CO",
      "flag_url": "co.png"
  }, {
      "name": "Comoros",
      "dial_code": "+269",
      "code": "KM",
      "flag_url": "km.png"
  }, {
      "name": "Congo",
      "dial_code": "+242",
      "code": "CG",
      "flag_url": "cg.png"
  }, {
      "name": "Congo, The Democratic Republic of the Congo",
      "dial_code": "+243",
      "code": "CD",
      "flag_url": "cd.png"
  }, {
      "name": "Cook Islands",
      "dial_code": "+682",
      "code": "CK",
      "flag_url": "ck.png"
  }, {
      "name": "Costa Rica",
      "dial_code": "+506",
      "code": "CR",
      "flag_url": "cr.png"
  }, {
      "name": "Cote d'Ivoire",
      "dial_code": "+225",
      "code": "CI",
      "flag_url": "ci.png"
  }, {
      "name": "Croatia",
      "dial_code": "+385",
      "code": "HR",
      "flag_url": "hr.png"
  }, {
      "name": "Cuba",
      "dial_code": "+53",
      "code": "CU",
      "flag_url": "cu.png"
  }, {
      "name": "Cyprus",
      "dial_code": "+357",
      "code": "CY",
      "flag_url": "cy.png"
  }, {
      "name": "Czech Republic",
      "dial_code": "+420",
      "code": "CZ",
      "flag_url": "cz.png"
  }, {
      "name": "Denmark",
      "dial_code": "+45",
      "code": "DK",
      "flag_url": "dk.png"
  }, {
      "name": "Djibouti",
      "dial_code": "+253",
      "code": "DJ",
      "flag_url": "dj.png"
  }, {
      "name": "Dominica",
      "dial_code": "+1767",
      "code": "DM",
      "flag_url": "dm.png"
  }, {
      "name": "Dominican Republic",
      "dial_code": "+1849",
      "code": "DO",
      "flag_url": "do.png"
  }, {
      "name": "Ecuador",
      "dial_code": "+593",
      "code": "EC",
      "flag_url": "ec.png"
  }, {
      "name": "Egypt",
      "dial_code": "+20",
      "code": "EG",
      "flag_url": "eg.png"
  }, {
      "name": "El Salvador",
      "dial_code": "+503",
      "code": "SV",
      "flag_url": "sv.png"
  }, {
      "name": "Equatorial Guinea",
      "dial_code": "+240",
      "code": "GQ",
      "flag_url": "gq.png"
  }, {
      "name": "Eritrea",
      "dial_code": "+291",
      "code": "ER",
      "flag_url": "er.png"
  }, {
      "name": "Estonia",
      "dial_code": "+372",
      "code": "EE",
      "flag_url": "ee.png"
  }, {
      "name": "Ethiopia",
      "dial_code": "+251",
      "code": "ET",
      "flag_url": "et.png"
  }, {
      "name": "Falkland Islands (Malvinas)",
      "dial_code": "+500",
      "code": "FK",
      "flag_url": "fk.png"
  }, {
      "name": "Faroe Islands",
      "dial_code": "+298",
      "code": "FO",
      "flag_url": "fo.png"
  }, {
      "name": "Fiji",
      "dial_code": "+679",
      "code": "FJ",
      "flag_url": "fj.png"
  }, {
      "name": "Finland",
      "dial_code": "+358",
      "code": "FI",
      "flag_url": "fi.png"
  }, {
      "name": "France",
      "dial_code": "+33",
      "code": "FR",
      "flag_url": "fr.png"
  }, {
      "name": "French Guiana",
      "dial_code": "+594",
      "code": "GF",
      "flag_url": "gf.png"
  }, {
      "name": "French Polynesia",
      "dial_code": "+689",
      "code": "PF",
      "flag_url": "pf.png"
  }, {
      "name": "Gabon",
      "dial_code": "+241",
      "code": "GA",
      "flag_url": "ga.png"
  }, {
      "name": "Gambia",
      "dial_code": "+220",
      "code": "GM",
      "flag_url": "gm.png"
  }, {
      "name": "Georgia",
      "dial_code": "+995",
      "code": "GE",
      "flag_url": "ge.png"
  }, {
      "name": "Germany",
      "dial_code": "+49",
      "code": "DE",
      "flag_url": "de.png"
  }, {
      "name": "Ghana",
      "dial_code": "+233",
      "code": "GH",
      "flag_url": "gh.png"
  }, {
      "name": "Gibraltar",
      "dial_code": "+350",
      "code": "GI",
      "flag_url": "gi.png"
  }, {
      "name": "Greece",
      "dial_code": "+30",
      "code": "GR",
      "flag_url": "gr.png"
  }, {
      "name": "Greenland",
      "dial_code": "+299",
      "code": "GL",
      "flag_url": "gl.png"
  }, {
      "name": "Grenada",
      "dial_code": "+1473",
      "code": "GD",
      "flag_url": "gd.png"
  }, {
      "name": "Guadeloupe",
      "dial_code": "+590",
      "code": "GP",
      "flag_url": "gp.png"
  }, {
      "name": "Guam",
      "dial_code": "+1671",
      "code": "GU",
      "flag_url": "gu.png"
  }, {
      "name": "Guatemala",
      "dial_code": "+502",
      "code": "GT",
      "flag_url": "gt.png"
  }, {
      "name": "Guernsey",
      "dial_code": "+44",
      "code": "GG",
      "flag_url": "gg.png"
  }, {
      "name": "Guinea",
      "dial_code": "+224",
      "code": "GN",
      "flag_url": "gn.png"
  }, {
      "name": "Guinea-Bissau",
      "dial_code": "+245",
      "code": "GW",
      "flag_url": "gw.png"
  }, {
      "name": "Guyana",
      "dial_code": "+592",
      "code": "GY",
      "flag_url": "gy.png"
  }, {
      "name": "Haiti",
      "dial_code": "+509",
      "code": "HT",
      "flag_url": "ht.png"
  }, {
      "name": "Holy See (Vatican City State)",
      "dial_code": "+379",
      "code": "VA",
      "flag_url": "va.png"
  }, {
      "name": "Honduras",
      "dial_code": "+504",
      "code": "HN",
      "flag_url": "hn.png"
  }, {
      "name": "Hong Kong",
      "dial_code": "+852",
      "code": "HK",
      "flag_url": "hk.png"
  }, {
      "name": "Hungary",
      "dial_code": "+36",
      "code": "HU",
      "flag_url": "hu.png"
  }, {
      "name": "Iceland",
      "dial_code": "+354",
      "code": "IS",
      "flag_url": "is.png"
  }, {
      "name": "India",
      "dial_code": "+91",
      "code": "IN",
      "flag_url": "in.png"
  }, {
      "name": "Indonesia",
      "dial_code": "+62",
      "code": "ID",
      "flag_url": "id.png"
  }, {
      "name": "Iran, Islamic Republic of Persian Gulf",
      "dial_code": "+98",
      "code": "IR",
      "flag_url": "ir.png"
  }, {
      "name": "Iraq",
      "dial_code": "+964",
      "code": "IQ",
      "flag_url": "iq.png"
  }, {
      "name": "Ireland",
      "dial_code": "+353",
      "code": "IE",
      "flag_url": "ie.png"
  }, {
      "name": "Isle of Man",
      "dial_code": "+44",
      "code": "IM",
      "flag_url": "im.png"
  }, {
      "name": "Israel",
      "dial_code": "+972",
      "code": "IL",
      "flag_url": "il.png"
  }, {
      "name": "Italy",
      "dial_code": "+39",
      "code": "IT",
      "flag_url": "it.png"
  }, {
      "name": "Jamaica",
      "dial_code": "+1876",
      "code": "JM",
      "flag_url": "jm.png"
  }, {
      "name": "Japan",
      "dial_code": "+81",
      "code": "JP",
      "flag_url": "jp.png"
  }, {
      "name": "Jersey",
      "dial_code": "+44",
      "code": "JE",
      "flag_url": "je.png"
  }, {
      "name": "Jordan",
      "dial_code": "+962",
      "code": "JO",
      "flag_url": "jo.png"
  }, {
      "name": "Kazakhstan",
      "dial_code": "+77",
      "code": "KZ",
      "flag_url": "kz.png"
  }, {
      "name": "Kenya",
      "dial_code": "+254",
      "code": "KE",
      "flag_url": "ke.png"
  }, {
      "name": "Kiribati",
      "dial_code": "+686",
      "code": "KI",
      "flag_url": "ki.png"
  }, {
      "name": "Korea, Democratic People's Republic of Korea",
      "dial_code": "+850",
      "code": "KP",
      "flag_url": "kp.png"
  }, {
      "name": "Korea, Republic of South Korea",
      "dial_code": "+82",
      "code": "KR",
      "flag_url": "kr.png"
  }, {
      "name": "Kuwait",
      "dial_code": "+965",
      "code": "KW",
      "flag_url": "kw.png"
  }, {
      "name": "Kyrgyzstan",
      "dial_code": "+996",
      "code": "KG",
      "flag_url": "kg.png"
  }, {
      "name": "Laos",
      "dial_code": "+856",
      "code": "LA",
      "flag_url": "la.png"
  }, {
      "name": "Latvia",
      "dial_code": "+371",
      "code": "LV",
      "flag_url": "lv.png"
  }, {
      "name": "Lebanon",
      "dial_code": "+961",
      "code": "LB",
      "flag_url": "lb.png"
  }, {
      "name": "Lesotho",
      "dial_code": "+266",
      "code": "LS",
      "flag_url": "ls.png"
  }, {
      "name": "Liberia",
      "dial_code": "+231",
      "code": "LR",
      "flag_url": "lr.png"
  }, {
      "name": "Libyan Arab Jamahiriya",
      "dial_code": "+218",
      "code": "LY",
      "flag_url": "ly.png"
  }, {
      "name": "Liechtenstein",
      "dial_code": "+423",
      "code": "LI",
      "flag_url": "li.png"
  }, {
      "name": "Lithuania",
      "dial_code": "+370",
      "code": "LT",
      "flag_url": "lt.png"
  }, {
      "name": "Luxembourg",
      "dial_code": "+352",
      "code": "LU",
      "flag_url": "lu.png"
  }, {
      "name": "Macao",
      "dial_code": "+853",
      "code": "MO",
      "flag_url": "mo.png"
  }, {
      "name": "Macedonia",
      "dial_code": "+389",
      "code": "MK",
      "flag_url": "mk.png"
  }, {
      "name": "Madagascar",
      "dial_code": "+261",
      "code": "MG",
      "flag_url": "mg.png"
  }, {
      "name": "Malawi",
      "dial_code": "+265",
      "code": "MW",
      "flag_url": "mw.png"
  }, {
      "name": "Malaysia",
      "dial_code": "+60",
      "code": "MY",
      "flag_url": "my.png"
  }, {
      "name": "Maldives",
      "dial_code": "+960",
      "code": "MV",
      "flag_url": "mv.png"
  }, {
      "name": "Mali",
      "dial_code": "+223",
      "code": "ML",
      "flag_url": "ml.png"
  }, {
      "name": "Malta",
      "dial_code": "+356",
      "code": "MT",
      "flag_url": "mt.png"
  }, {
      "name": "Marshall Islands",
      "dial_code": "+692",
      "code": "MH",
      "flag_url": "mh.png"
  }, {
      "name": "Martinique",
      "dial_code": "+596",
      "code": "MQ",
      "flag_url": "mq.png"
  }, {
      "name": "Mauritania",
      "dial_code": "+222",
      "code": "MR",
      "flag_url": "mr.png"
  }, {
      "name": "Mauritius",
      "dial_code": "+230",
      "code": "MU",
      "flag_url": "mu.png"
  }, {
      "name": "Mayotte",
      "dial_code": "+262",
      "code": "YT",
      "flag_url": "yt.png"
  }, {
      "name": "Mexico",
      "dial_code": "+52",
      "code": "MX",
      "flag_url": "mx.png"
  }, {
      "name": "Micronesia, Federated States of Micronesia",
      "dial_code": "+691",
      "code": "FM",
      "flag_url": "fm.png"
  }, {
      "name": "Moldova",
      "dial_code": "+373",
      "code": "MD",
      "flag_url": "md.png"
  }, {
      "name": "Monaco",
      "dial_code": "+377",
      "code": "MC",
      "flag_url": "mc.png"
  }, {
      "name": "Mongolia",
      "dial_code": "+976",
      "code": "MN",
      "flag_url": "mn.png"
  }, {
      "name": "Montenegro",
      "dial_code": "+382",
      "code": "ME",
      "flag_url": "me.png"
  }, {
      "name": "Montserrat",
      "dial_code": "+1664",
      "code": "MS",
      "flag_url": "ms.png"
  }, {
      "name": "Morocco",
      "dial_code": "+212",
      "code": "MA",
      "flag_url": "ma.png"
  }, {
      "name": "Mozambique",
      "dial_code": "+258",
      "code": "MZ",
      "flag_url": "mz.png"
  }, {
      "name": "Myanmar",
      "dial_code": "+95",
      "code": "MM",
      "flag_url": "mm.png"
  }, {
      "name": "Namibia",
      "dial_code": "+264",
      "code": "NA",
      "flag_url": "na.png"
  }, {
      "name": "Nauru",
      "dial_code": "+674",
      "code": "NR",
      "flag_url": "nr.png"
  }, {
      "name": "Nepal",
      "dial_code": "+977",
      "code": "NP",
      "flag_url": "np.png"
  }, {
      "name": "Netherlands",
      "dial_code": "+31",
      "code": "NL",
      "flag_url": "nl.png"
  }, {
      "name": "Netherlands Antilles",
      "dial_code": "+599",
      "code": "AN",
      "flag_url": "an.png"
  }, {
      "name": "New Caledonia",
      "dial_code": "+687",
      "code": "NC",
      "flag_url": "nc.png"
  }, {
      "name": "New Zealand",
      "dial_code": "+64",
      "code": "NZ",
      "flag_url": "nz.png"
  }, {
      "name": "Nicaragua",
      "dial_code": "+505",
      "code": "NI",
      "flag_url": "ni.png"
  }, {
      "name": "Niger",
      "dial_code": "+227",
      "code": "NE",
      "flag_url": "ne.png"
  }, {
      "name": "Nigeria",
      "dial_code": "+234",
      "code": "NG",
      "flag_url": "ng.png"
  }, {
      "name": "Niue",
      "dial_code": "+683",
      "code": "NU",
      "flag_url": "nu.png"
  }, {
      "name": "Norfolk Island",
      "dial_code": "+672",
      "code": "NF",
      "flag_url": "nf.png"
  }, {
      "name": "Northern Mariana Islands",
      "dial_code": "+1670",
      "code": "MP",
      "flag_url": "mp.png"
  }, {
      "name": "Norway",
      "dial_code": "+47",
      "code": "NO",
      "flag_url": "no.png"
  }, {
      "name": "Oman",
      "dial_code": "+968",
      "code": "OM",
      "flag_url": "om.png"
  }, {
      "name": "Pakistan",
      "dial_code": "+92",
      "code": "PK",
      "flag_url": "pk.png"
  }, {
      "name": "Palau",
      "dial_code": "+680",
      "code": "PW",
      "flag_url": "pw.png"
  }, {
      "name": "Palestinian Territory, Occupied",
      "dial_code": "+970",
      "code": "PS",
      "flag_url": "ps.png"
  }, {
      "name": "Panama",
      "dial_code": "+507",
      "code": "PA",
      "flag_url": "pa.png"
  }, {
      "name": "Papua New Guinea",
      "dial_code": "+675",
      "code": "PG",
      "flag_url": "pg.png"
  }, {
      "name": "Paraguay",
      "dial_code": "+595",
      "code": "PY",
      "flag_url": "py.png"
  }, {
      "name": "Peru",
      "dial_code": "+51",
      "code": "PE",
      "flag_url": "pe.png"
  }, {
      "name": "Philippines",
      "dial_code": "+63",
      "code": "PH",
      "flag_url": "ph.png"
  }, {
      "name": "Pitcairn",
      "dial_code": "+872",
      "code": "PN",
      "flag_url": "pn.png"
  }, {
      "name": "Poland",
      "dial_code": "+48",
      "code": "PL",
      "flag_url": "pl.png"
  }, {
      "name": "Portugal",
      "dial_code": "+351",
      "code": "PT",
      "flag_url": "pt.png"
  }, {
      "name": "Puerto Rico",
      "dial_code": "+1939",
      "code": "PR",
      "flag_url": "pr.png"
  }, {
      "name": "Qatar",
      "dial_code": "+974",
      "code": "QA",
      "flag_url": "qa.png"
  }, {
      "name": "Romania",
      "dial_code": "+40",
      "code": "RO",
      "flag_url": "ro.png"
  }, {
      "name": "Russia",
      "dial_code": "+7",
      "code": "RU",
      "flag_url": "ru.png"
  }, {
      "name": "Rwanda",
      "dial_code": "+250",
      "code": "RW",
      "flag_url": "rw.png"
  }, {
      "name": "Reunion",
      "dial_code": "+262",
      "code": "RE",
      "flag_url": "re.png"
  }, {
      "name": "Saint Barthelemy",
      "dial_code": "+590",
      "code": "BL",
      "flag_url": "bl.png"
  }, {
      "name": "Saint Helena, Ascension and Tristan Da Cunha",
      "dial_code": "+290",
      "code": "SH",
      "flag_url": "sh.png"
  }, {
      "name": "Saint Kitts and Nevis",
      "dial_code": "+1869",
      "code": "KN",
      "flag_url": "kn.png"
  }, {
      "name": "Saint Lucia",
      "dial_code": "+1758",
      "code": "LC",
      "flag_url": "lc.png"
  }, {
      "name": "Saint Martin",
      "dial_code": "+590",
      "code": "MF",
      "flag_url": "mf.png"
  }, {
      "name": "Saint Pierre and Miquelon",
      "dial_code": "+508",
      "code": "PM",
      "flag_url": "pm.png"
  }, {
      "name": "Saint Vincent and the Grenadines",
      "dial_code": "+1784",
      "code": "VC",
      "flag_url": "vc.png"
  }, {
      "name": "Samoa",
      "dial_code": "+685",
      "code": "WS",
      "flag_url": "ws.png"
  }, {
      "name": "San Marino",
      "dial_code": "+378",
      "code": "SM",
      "flag_url": "sm.png"
  }, {
      "name": "Sao Tome and Principe",
      "dial_code": "+239",
      "code": "ST",
      "flag_url": "st.png"
  }, {
      "name": "Saudi Arabia",
      "dial_code": "+966",
      "code": "SA",
      "flag_url": "sa.png"
  }, {
      "name": "Senegal",
      "dial_code": "+221",
      "code": "SN",
      "flag_url": "sn.png"
  }, {
      "name": "Serbia",
      "dial_code": "+381",
      "code": "RS",
      "flag_url": "rs.png"
  }, {
      "name": "Seychelles",
      "dial_code": "+248",
      "code": "SC",
      "flag_url": "sc.png"
  }, {
      "name": "Sierra Leone",
      "dial_code": "+232",
      "code": "SL",
      "flag_url": "sl.png"
  }, {
      "name": "Singapore",
      "dial_code": "+65",
      "code": "SG",
      "flag_url": "sg.png"
  }, {
      "name": "Slovakia",
      "dial_code": "+421",
      "code": "SK",
      "flag_url": "sk.png"
  }, {
      "name": "Slovenia",
      "dial_code": "+386",
      "code": "SI",
      "flag_url": "si.png"
  }, {
      "name": "Solomon Islands",
      "dial_code": "+677",
      "code": "SB",
      "flag_url": "sb.png"
  }, {
      "name": "Somalia",
      "dial_code": "+252",
      "code": "SO",
      "flag_url": "so.png"
  }, {
      "name": "South Africa",
      "dial_code": "+27",
      "code": "ZA",
      "flag_url": "za.png"
  }, {
      "name": "South Georgia and the South Sandwich Islands",
      "dial_code": "+500",
      "code": "GS",
      "flag_url": "gs.png"
  }, {
      "name": "Spain",
      "dial_code": "+34",
      "code": "ES",
      "flag_url": "es.png"
  }, {
      "name": "Sri Lanka",
      "dial_code": "+94",
      "code": "LK",
      "flag_url": "lk.png"
  }, {
      "name": "Sudan",
      "dial_code": "+249",
      "code": "SD",
      "flag_url": "sd.png"
  }, {
      "name": "Suriname",
      "dial_code": "+597",
      "code": "SR",
      "flag_url": "sr.png"
  }, {
      "name": "Svalbard and Jan Mayen",
      "dial_code": "+47",
      "code": "SJ",
      "flag_url": "sj.png"
  }, {
      "name": "Swaziland",
      "dial_code": "+268",
      "code": "SZ",
      "flag_url": "sz.png"
  }, {
      "name": "Sweden",
      "dial_code": "+46",
      "code": "SE",
      "flag_url": "se.png"
  }, {
      "name": "Switzerland",
      "dial_code": "+41",
      "code": "CH",
      "flag_url": "ch.png"
  }, {
      "name": "Syrian Arab Republic",
      "dial_code": "+963",
      "code": "SY",
      "flag_url": "sy.png"
  }, {
      "name": "Taiwan",
      "dial_code": "+886",
      "code": "TW",
      "flag_url": "tw.png"
  }, {
      "name": "Tajikistan",
      "dial_code": "+992",
      "code": "TJ",
      "flag_url": "tj.png"
  }, {
      "name": "Tanzania, United Republic of Tanzania",
      "dial_code": "+255",
      "code": "TZ",
      "flag_url": "tz.png"
  }, {
      "name": "Thailand",
      "dial_code": "+66",
      "code": "TH",
      "flag_url": "th.png"
  }, {
      "name": "Timor-Leste",
      "dial_code": "+670",
      "code": "TL",
      "flag_url": "tl.png"
  }, {
      "name": "Togo",
      "dial_code": "+228",
      "code": "TG",
      "flag_url": "tg.png"
  }, {
      "name": "Tokelau",
      "dial_code": "+690",
      "code": "TK",
      "flag_url": "tk.png"
  }, {
      "name": "Tonga",
      "dial_code": "+676",
      "code": "TO",
      "flag_url": "to.png"
  }, {
      "name": "Trinidad and Tobago",
      "dial_code": "+1868",
      "code": "TT",
      "flag_url": "tt.png"
  }, {
      "name": "Tunisia",
      "dial_code": "+216",
      "code": "TN",
      "flag_url": "tn.png"
  }, {
      "name": "Turkey",
      "dial_code": "+90",
      "code": "TR",
      "flag_url": "tr.png"
  }, {
      "name": "Turkmenistan",
      "dial_code": "+993",
      "code": "TM",
      "flag_url": "tm.png"
  }, {
      "name": "Turks and Caicos Islands",
      "dial_code": "+1649",
      "code": "TC",
      "flag_url": "tc.png"
  }, {
      "name": "Tuvalu",
      "dial_code": "+688",
      "code": "TV",
      "flag_url": "tv.png"
  }, {
      "name": "Uganda",
      "dial_code": "+256",
      "code": "UG",
      "flag_url": "ug.png"
  }, {
      "name": "Ukraine",
      "dial_code": "+380",
      "code": "UA",
      "flag_url": "ua.png"
  }, {
      "name": "United Arab Emirates",
      "dial_code": "+971",
      "code": "AE",
      "flag_url": "ae.png"
  }, {
      "name": "United Kingdom",
      "dial_code": "+44",
      "code": "GB",
      "flag_url": "gb.png"
  }, {
      "name": "United States",
      "dial_code": "+1",
      "code": "US",
      "flag_url": "us.png"
  }, {
      "name": "Uruguay",
      "dial_code": "+598",
      "code": "UY",
      "flag_url": "uy.png"
  }, {
      "name": "Uzbekistan",
      "dial_code": "+998",
      "code": "UZ",
      "flag_url": "uz.png"
  }, {
      "name": "Vanuatu",
      "dial_code": "+678",
      "code": "VU",
      "flag_url": "vu.png"
  }, {
      "name": "Venezuela, Bolivarian Republic of Venezuela",
      "dial_code": "+58",
      "code": "VE",
      "flag_url": "ve.png"
  }, {
      "name": "Vietnam",
      "dial_code": "+84",
      "code": "VN",
      "flag_url": "vn.png"
  }, {
      "name": "Virgin Islands, British",
      "dial_code": "+1284",
      "code": "VG",
      "flag_url": "vg.png"
  }, {
      "name": "Virgin Islands, U.S.",
      "dial_code": "+1340",
      "code": "VI",
      "flag_url": "vi.png"
  }, {
      "name": "Wallis and Futuna",
      "dial_code": "+681",
      "code": "WF",
      "flag_url": "wf.png"
  }, {
      "name": "Yemen",
      "dial_code": "+967",
      "code": "YE",
      "flag_url": "ye.png"
  }, {
      "name": "Zambia",
      "dial_code": "+260",
      "code": "ZM",
      "flag_url": "zm.png"
  }, {
      "name": "Zimbabwe",
      "dial_code": "+263",
      "code": "ZW",
      "flag_url": "zw.png"
  }
]
